// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-camp-order .camp-order-row-card{padding:12px;border:1px solid #dee2e6;border-radius:6px;margin-bottom:8px;background:#fff;cursor:pointer}.my-camp-order .camp-order-table td{vertical-align:middle;padding-top:.75rem;padding-bottom:.75rem}.my-camp-order .camp-order-table td:first-child>div{white-space:nowrap}.my-camp-order .camp-order-row-card.card-unpaid,.my-camp-order .camp-order-table .payment-unpaid td{background-color:#fff8e1}", ""]);
// Exports
module.exports = exports;
